<template>
  <v-row justify="center" v-if="variables">
    <v-expansion-panels hover="" focusable="" :multiple="false" popout>
      <v-expansion-panel v-for="(item, index) in variables" :key="index">
        <v-expansion-panel-header
          v-html="
            `[${$t(`groups.${item.groups}`)}] ${$t(`variables.${item.code}`)}`
          "
        >
        </v-expansion-panel-header>
        <v-expansion-panel-content
          :color="$vuetify.theme.dark ? '#121212' : '#E0E0E0'"
        >
          <!--  <toggle-variables :index="index"></toggle-variables> -->
          <template>
            <base-material-card color="primary" inline class="my-12">
              <template v-slot:heading>
                <v-chip label color="white" class="primary--text">
                  {{ item.groups }}
                </v-chip>
                <div
                  :class="
                    $vuetify.breakpoint.xsOnly
                      ? 'subtitle-2 text-truncate font-weight-light'
                      : 'subtitle-1   font-weight-light text-truncate'
                  "
                >
                  <edit-variable-tag
                    v-on="$listeners"
                    :variable="item"
                    :index="index"
                  ></edit-variable-tag>
                </div>
              </template>

              <v-card-text>
                <slider
                  @setValues="setValues"
                  :variable="item"
                  :index="index"
                ></slider
              ></v-card-text>
            </base-material-card>
          </template>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  components: {
    slider: () => import("./VueSlider.vue"),
    editVariableTag: () => import("./EditVariableTag.vue")
    /*    "toggle-variables": () => import("../ToggleVariables") */
  },

  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    variables() {
      return this.equipmentProfile?.variables
        ? this.equipmentProfile?.variables
        : null;
    }
  },
  data() {
    return {
      isEditTagMode: false,
      tagName: ""
    };
  },
  methods: {
    setValues() {
      this.$emit("setValues");
    }
  }
};
</script>

<style></style>
